<template>
    <div :style="styleObject" class="page-header align-items-start min-vh-100 mbr-pf">
        <span class="mask bg-white"></span>
        <div class="container">
            <div class="row">
                <div class="notifications">
                    <material-alert v-if="error" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                        {{ error }}
                    </material-alert>
                </div>
                <div class="col-lg-12 col-md-8 col-12 mx-auto">
                    <div class="card-body">
                        <div>
                            <!-- <div class="color-common pb-3 font-weight-bolder h4"
                                :style="`color: ${this.$store.state.labelColor} !important`">
                                My Minty Profile
                            </div> -->
                            <div class="pb-3 font-weight-bolder text-dark title-share-profile" v-if="!isShowShareData">
                                {{ $t('profile.share_from_minty') + ' ' }}<a class="text-decoration-underline btn-share-profile"
                                    data-bs-toggle="modal" data-bs-target="#bottom_modal_share_profile">{{ $t('profile.share_now') }}</a><i
                                    class="fa fa-times ps-2" aria-hidden="true"></i>
                            </div>
                            <div class="mbr-pf__identity">
                                <div class="mbr-pf__avatar" aria-hidden="true">
                                    <span v-if="initials">{{ initials }}</span>
                                    <i v-else class="material-icons-round">person</i>
                                </div>
                                <p v-if="memberInfo.id" class="mbr-pf__member-id">{{ $t('profile.member_id', { id: memberInfo.id }) }}</p>
                            </div>
                            <div class="mbr-pf__pair" v-if="displayFields && (displayFields.isNameDisplay || displayFields.isLastNameDisplay)">
                                <div class="mbr-pf__field" v-if="displayFields.isNameDisplay">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ $t('profile.first_name') }}<span v-if="required && required.isNameRequire" class="mbr-pf__req"> *</span></label>
                                        <i v-if="reward && reward.isNameReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <material-input id="name" name="name" v-model="form.name" />
                                </div>
                                <div class="mbr-pf__field" v-if="displayFields.isLastNameDisplay">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ $t('profile.last_name') }}<span v-if="required && required.isLastNameRequire" class="mbr-pf__req"> *</span></label>
                                        <i v-if="reward && reward.isLastNameReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <material-input id="name" name="name" v-model="form.last_name" />
                                </div>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isNRICDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.nric') }}<span v-if="required && required.isNRICRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isNRICReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <material-input id="name" name="name" v-model="form.nric" />
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isDateDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.date_of_birth') }}<span v-if="required && required.isDateRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isDateReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <!-- iOS centres a native date input and uses its own locale format; draw the locked box and lay the picker over it -->
                                <div v-if="!dateOfBirthBefore && !check_birthday_reward" class="mbr-pf__box mbr-pf__date">
                                    <span v-if="form.date_of_birth" class="mbr-pf__value">{{ formatDate(form.date_of_birth) }}</span>
                                    <span v-else class="mbr-pf__value mbr-pf__value--placeholder">{{ $t('profile.date_placeholder') }}</span>
                                    <i class="material-icons-round mbr-pf__box-icon" aria-hidden="true">calendar_today</i>
                                    <input id="date_of_birth" type="date" name="date_of_birth" class="mbr-pf__date-input"
                                        :aria-label="$t('profile.date_of_birth')" v-model="form.date_of_birth" />
                                </div>
                                <button v-if="dateOfBirthBefore" type="button" class="mbr-pf__box" @click="warningCannotUpdateBirthday()">
                                    <span class="mbr-pf__value">{{ formatDate(form.date_of_birth) }}</span>
                                    <i class="material-icons-round mbr-pf__box-icon" aria-hidden="true">calendar_today</i>
                                </button>
                                <span class="mbr-pf__error" v-if="dateOfBirthBefore && isWarningCannotUpdateBirthday">{{ $t('profile.birthday_change_once') }}</span>
                                <div class="mbr-pf__note">
                                    <span class="mbr-pf__note-icon" aria-hidden="true">i</span>
                                    <p>{{ $t('profile.birthday_note') }}</p>
                                </div>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isGenderDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.gender') }}<span v-if="required && required.isGenderRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isGenderReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <div class="mbr-pf__segment" role="radiogroup" :aria-label="$t('profile.gender')">
                                    <button type="button" role="radio" class="mbr-pf__segment-btn" :class="{ 'is-active': form.gender === '1' }"
                                        :aria-checked="form.gender === '1'" @click="form.gender = '1'">{{ $t('profile.male') }}</button>
                                    <button type="button" role="radio" class="mbr-pf__segment-btn" :class="{ 'is-active': form.gender === '2' }"
                                        :aria-checked="form.gender === '2'" @click="form.gender = '2'">{{ $t('profile.female') }}</button>
                                </div>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isEmailDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.email') }}<span v-if="required && required.isEmailRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isEmailReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <material-input id="email" type="email" name="email" v-model="form.email" />
                            </div>
                            <div class="mbr-pf__field">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.mobile_number') }}<span class="mbr-pf__req"> *</span></label>
                                    <!-- Outside the change flow the number is read-only; Change starts sendOTP() as before -->
                                    <button v-if="!isChangingPhone" type="button" class="mbr-pf__link" :disabled="isDisableGetOtpBtn" @click="sendOTP()">{{ $t('profile.change') }}</button>
                                </div>
                                <div v-if="!isChangingPhone" class="mbr-pf__box mbr-pf__box--tint">
                                    <span class="mbr-pf__phone">
                                        <template v-if="form.phone_code">
                                            <strong>+{{ form.phone_code }}</strong>
                                            <span class="mbr-pf__divider" aria-hidden="true"></span>
                                        </template>
                                        <span class="mbr-pf__value">{{ form.phone_number }}</span>
                                    </span>
                                    <span class="mbr-pf__verified">
                                        <i class="material-icons-round" aria-hidden="true">check</i>{{ $t('profile.verified') }}
                                    </span>
                                </div>
                                <div v-else class="mbr-pf__phone-edit">
                                    <select :disabled="checkAllowForeignerPhoneNumber == 'false' || checkAllowForeignerPhoneNumber == false" id="country_id" class="form-select mbr-pf__select mbr-pf__select--code" v-model="form.phone_code">
                                        <option v-for="(value, key) in phoneCodeOptions" :key="key" :value="value.value">
                                        {{value.label}}
                                        </option>
                                    </select>
                                    <material-input id="phone_number" type="tel" name="phone_number" class="mbr-pf__phone-input"
                                        :disabled="isDisablePhoneInput" v-model="form.phone_number"
                                        @input="onChangePhoneNumber" />
                                    <material-button class="mbr-pf__otp-btn" @click="sendOTP()" :disabled="isDisableGetOtpBtn">
                                        <span v-html="countDownLabel"></span>
                                    </material-button>
                                </div>
                                <button type="button" style="display: none;" class="open-modal" name="open_modal"
                                    data-bs-toggle="modal" data-bs-target="#exampleModal"></button>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isHouseAddressDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.address') }}<span v-if="required && required.isHouseAddressRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isHouseAddressReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <material-input id="address_1" name="address_1" v-model="form.address_1" />
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isAddress2Display">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.address_2') }}<span v-if="required && required.isAddress2Require" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isAddress2Reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <material-input id="address_2" name="address_2" v-model="form.address_2" />
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isPostCodeDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.postal_code') }}<span v-if="required && required.isPostCodeRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isPostCodeReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <material-input id="postal_code" name="postal_code" v-model="form.postal_code" />
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isOccupationDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.occupation') }}<span v-if="required && required.isOccupationRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isOccupationReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <material-input id="occupation" name="occupation" v-model="form.occupation" />
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isMonthlyIncomeRangeDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.monthly_income_range') }}<span v-if="required && required.isMonthlyIncomeRangeRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isMonthlyIncomeRangeReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <div class="mbr-pf__choices">
                                    <MaterialRadio id="range_1" name="monthly_income_range" value="1" v-model="form.monthly_income_range">
                                        $0 - $3,000
                                    </MaterialRadio>
                                    <MaterialRadio id="range_2" name="monthly_income_range" value="2" v-model="form.monthly_income_range">
                                        $3,001 - $6,000
                                    </MaterialRadio>
                                    <MaterialRadio id="range_3" name="monthly_income_range" value="3" v-model="form.monthly_income_range">
                                        $6,001 - $9,000
                                    </MaterialRadio>
                                    <MaterialRadio id="range_4" name="monthly_income_range" value="4" v-model="form.monthly_income_range">
                                        {{ $t('profile.income_above', { amount: '$9,000' }) }}
                                    </MaterialRadio>
                                </div>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isMaritalStatusDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.marital_status') }}<span v-if="required && required.isMaritalStatusRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isMaritalStatusReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <select id="marital_status" class="form-select mbr-pf__select" v-model="form.marital_status">
                                    <option value="">{{ $t('profile.select_marital_status') }}</option>
                                    <option value="1">{{ $t('profile.married') }}</option>
                                    <option value="2">{{ $t('profile.single') }}</option>
                                </select>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isDiscoveryDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.discovery_channel') }}<span v-if="required && required.isDiscoveryRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isDiscoveryReward" class="fas fa-gift mbr-pf__gift"></i>
                                </div>
                                <select id="discovery_channel" class="form-select mbr-pf__select" v-model="form.discovery_channel">
                                    <option value="">{{ $t('profile.select_discovery_channel') }}</option>
                                    <option value="1">{{ $t('profile.social_media') }}</option>
                                    <option value="2">{{ $t('profile.traditional_media') }}</option>
                                    <option value="3">{{ $t('profile.word_of_mouth') }}</option>
                                    <option value="4">{{ $t('profile.events') }}</option>
                                    <option value="5">{{ $t('profile.others') }}</option>
                                </select>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isCountryOfResidentDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.country_of_resident') }}<span v-if="required && required.isCountryOfResidentRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isCountryOfResidentReward" class="fas fa-gift mbr-pf__gift"></i>
                                </div>
                                <select id="country_id" class="form-select mbr-pf__select" v-model="form.country_id">
                                    <option value="">{{ $t('profile.select_country_of_resident') }}</option>
                                    <option v-for="(value, key) in countries" :key="key" :value="value.id">{{ value.country_name }}</option>
                                </select>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isEducationDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.education') }}<span v-if="required && required.isEducationRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isEducationReward" class="fas fa-gift mbr-pf__gift"></i>
                                </div>
                                <select id="education" class="form-select mbr-pf__select" v-model="form.education">
                                    <option value="">{{ $t('profile.select_education') }}</option>
                                    <option value="1">{{ $t('profile.secondary') }}</option>
                                    <option value="2">{{ $t('profile.tertiary_education') }}</option>
                                    <option value="3">{{ $t('profile.bachelor') }}</option>
                                    <option value="4">{{ $t('profile.postgraduate') }}</option>
                                </select>
                            </div>
                            <div v-for="(value, key) in form.fields_another" :key="key">
                                <div class="mbr-pf__field" v-if="value.is_short_anwser == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <material-input :id="value.field_name_convert" :name="value.field_name_convert" v-model="value.field_value" />
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_paragraph == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <material-textarea :id="value.field_name_convert" :name="value.field_name_convert" v-model="value.field_value" />
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_date == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <Datepicker
                                        v-model="value.field_value"
                                        :enableTimePicker="false"
                                        :locale="dateLocale()"
                                        :placeholder="$t('profile.select_date')"
                                        :selectText="$t('profile.select')"
                                        :cancelText="$t('common.cancel')"
                                        class="mbr-pf__picker"
                                    />
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_time == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <Datepicker
                                        v-model="value.field_value"
                                        timePicker
                                        :locale="dateLocale()"
                                        :placeholder="$t('profile.select_time')"
                                        :selectText="$t('profile.select')"
                                        :cancelText="$t('common.cancel')"
                                        class="mbr-pf__picker"
                                    />
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_single_choice == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <div class="mbr-pf__choices">
                                        <MaterialRadio
                                            v-for="(option, index) in value.options"
                                            :key="index"
                                            :id="option.id"
                                            :value="option.id"
                                            v-model="value.field_value"
                                        >
                                            {{ option.name }}
                                        </MaterialRadio>
                                    </div>
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_multiple_choice == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <div class="mbr-pf__choices">
                                        <div v-for="(option, index) in value.options" :key="index" class="mbr-pf__check">
                                            <material-checkbox
                                                @change="addMultipleChoice(value, option)"
                                                :checked="option.checked === option.id"
                                                :name="value.field_name_convert"
                                                :id="value.field_name_convert"
                                                class="checkbox-custom"
                                            ></material-checkbox>
                                            <span class="mbr-pf__check-label">{{ option.name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_dropdown_list == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <Multiselect
                                        v-model="value.field_value"
                                        :options="value.options"
                                        :placeholder="$t('profile.select')"
                                        :canClear="false"
                                        class="mbr-pf__multiselect"
                                    />
                                </div>
                                <div class="mbr-pf__field" v-if="value.is_file_upload == 1 && value.is_display == 1">
                                    <div class="mbr-pf__label-row">
                                        <label class="mbr-pf__label">{{ value.field_name }}<span v-if="value && value.is_required" class="mbr-pf__req"> *</span></label>
                                        <i v-if="value && value.is_reward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                    </div>
                                    <div class="mbr-pf__upload">
                                        <material-input
                                            style="display: none"
                                            type="file"
                                            :id="value.field_name_convert"
                                            @click="uploadFile(value)"
                                            @change="handleFileUpload($event, value)"
                                            accept="image/*"
                                        />
                                        <material-button variant="outline" size="sm" @click="uploadFile(value)">
                                            {{ $t('profile.upload_file') }}
                                        </material-button>
                                        <span class="mbr-pf__hint">{{ $t('profile.upload_hint') }}</span>
                                    </div>
                                    <div v-if="value.field_value_preview || value.field_value" class="mbr-pf__thumb">
                                        <img :src="value.field_value_preview || value.field_value" alt="" />
                                        <button type="button" class="mbr-pf__thumb-remove" :aria-label="$t('profile.remove_image')" @click="clearImage(value)">
                                            <i class="material-icons-round" aria-hidden="true">close</i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isReceiveOffersDisplay">
                                <p class="mbr-pf__question">{{ $t('profile.receive_offers') }}</p>
                                <div class="mbr-pf__inline-choices">
                                    <MaterialRadio id="receive_offers_yes" name="receive_offers" value="1" v-model="form.receive_offers">
                                        {{ $t('common.yes') }}
                                    </MaterialRadio>
                                    <MaterialRadio id="receive_offers_no" name="receive_offers" value="0" v-model="form.receive_offers">
                                        {{ $t('common.no') }}
                                    </MaterialRadio>
                                </div>
                            </div>
                            <div class="mbr-pf__field" v-if="displayFields && displayFields.isPasscodeDisplay">
                                <div class="mbr-pf__label-row">
                                    <label class="mbr-pf__label">{{ $t('profile.passcode') }}<span v-if="required && required.isPasscodeRequire" class="mbr-pf__req"> *</span></label>
                                    <i v-if="reward && reward.isPasscodeReward" class="fas fa-gift mbr-pf__gift" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="$t('profile.fill_for_reward')" :data-bs-original-title="$t('profile.fill_for_reward')"></i>
                                </div>
                                <p class="mbr-pf__pin-hint">{{ $t('profile.passcode_keep_hint') }}</p>
                                <div class="mbr-pf__pin mbr-pf__pin--center">
                                    <v-otp-input input-classes="otp-input" separator="" :num-inputs="4"
                                        ref="inputPasscode" input-type="password" :is-input-num="true"
                                        :conditionalClass="['one', 'two', 'three', 'four']" v-model="form.passcode"
                                        @on-complete="handleOnCompletePasscode" @on-change="handleOnChangePasscode" />
                                </div>
                            </div>
                            <div class="mbr-pf__savebar">
                                <!-- <material-button v-if="memberInfo.phone_number" @click="backToHome()" class="mb-3 col-lg-4 col-md-5 col-6 bg-green"
                                    :style="`background: ${this.$store.state.buttonColor} !important; color: ${this.$store.state.buttonTextColor} !important;`">
                                    Back to home
                                </material-button> -->
                                <!-- <material-button v-if="memberInfo.phone_number" @click="updateProfile()" class="mb-3 col-lg-4 col-md-5 col-6 bg-green"
                                    :style="`background: ${this.$store.state.buttonColor} !important; color: ${this.$store.state.buttonTextColor} !important;`">
                                    Save
                                </material-button> -->
                                <material-button size="lg" full-width class="mbr-pf__save" @click="updateProfile()">
                                    {{ $t('common.save') }}
                                </material-button>
                            </div>
                            <div class="mbr-pf__deactivate-row" v-if="displayFields && displayFields.isSelfDeactivateDisplay">
                                <button type="button" class="mbr-pf__deactivate" @click="confirmDeactivateMember()">{{ $t('profile.deactivate_account') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2">
            <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date=""
                :description="message" :icon="{ component: 'campaign', color: 'white' }" :color="snackbar"
                :close-handler="closeSnackbar" />
        </div>
        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            ref="vuemodal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content mbr-pf-modal">
                    <div class="mbr-pf-modal__header">
                        <h5 class="mbr-pf-modal__title" id="exampleModalLabel">{{ $t('profile.enter_otp') }}</h5>
                        <!-- keep .btn-close: the countdown watcher and getMemberInfo() click it through jQuery -->
                        <button type="button" class="btn-close mbr-pf-modal__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
                            <i class="material-icons-round" aria-hidden="true">close</i>
                        </button>
                    </div>
                    <div class="mbr-pf-modal__body">
                        <label class="mbr-pf__label">{{ $t('profile.otp_4_digit') }}</label>
                        <div class="mbr-pf__pin mbr-pf__pin--center">
                            <v-otp-input ref="inputOTP" input-classes="otp-input" separator="-" :num-inputs="4"
                                :is-input-num="true" :conditionalClass="['one', 'two', 'three', 'four']"
                                :placeholder="['*', '*', '*', '*']" v-model="form.otp"
                                @on-complete="handleOnComplete" @on-change="handleOnChange" />
                        </div>
                    </div>
                    <div class="mbr-pf-modal__footer">
                        <div class="mbr-pf-modal__countdown" v-if="countDown > 0" v-html="countDownLabel"></div>
                        <material-button size="lg" full-width :disabled="isShowOkOtpButton" data-bs-dismiss="modal">{{ $t('common.ok') }}</material-button>
                    </div>
                </div>
            </div>
            <material-loading :active="loaderActive" />
        </div>
        <!-- Modal -->
        <ModalConfirm :message="$t('profile.sync_confirm')"
            :btnYes="$t('profile.sync_yes')" :sycn-profile="processSycnProfile" />

        <ModalConfirmDeactivateMember :btnYes="$t('common.yes')" :sycn-profile="deactivateMember" />

        <ModalCongratulation :message="congratulationName" :btnClose="$t('common.close')"
            :btnGo="$t('reward.go_to_my_reward')" :voucherIconUrl="voucherIconUrl" :memberInfo="memberInfo"/>

            <div class="modal modal-bottom fade mbr-pf-sheet" id="bottom_modal_finished_reward_profile" tabindex="-1" role="dialog"
            aria-labelledby="bottom_modal_finished_reward_profile" style="z-index: 10000;">
            <div class="modal-dialog" role="document">
            <div class="modal-content mbr-pf-sheet__content">
                <div class="mbr-pf-sheet__top">
                    <span class="mbr-pf-sheet__handle" aria-hidden="true"></span>
                    <button type="button" class="mbr-pf-modal__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
                        <i class="material-icons-round" aria-hidden="true">close</i>
                    </button>
                </div>
                <div class="mbr-pf-sheet__body">
                    <p class="mbr-pf-sheet__title">{{ $t('profile.fill_reward_fields') }}</p>
                    <span v-if="reward && reward.isNameReward || reward && reward.isLastNameReward" class="mbr-pf-sheet__emblem" aria-hidden="true">
                        <i class="fas fa-gift"></i>
                    </span>
                    <p class="mbr-pf-sheet__sub">{{ $t('profile.get_amazing_reward') }}</p>
                </div>
                <div class="mbr-pf-sheet__actions">
                    <!-- keep .close-model: processSycnProfile() clicks it through jQuery -->
                    <material-button size="lg" variant="outline" class="close-model" @click="handleUpdateProfile">
                    {{ $t('profile.no_thanks') }}
                    </material-button>
                    <material-button size="lg" data-bs-dismiss="modal">
                    {{ $t('profile.fill_profile') }}
                    </material-button>
                </div>
            </div>
            </div>
            <button type="button" class="btn btn-primary btn-close-modal btn-sm" data-bs-dismiss="modal" style="display: none">Cancel</button>
            <button class="btn-finished-profile-reward-modal" style="display: none" data-bs-toggle="modal"
            data-bs-target="#bottom_modal_finished_reward_profile">Success</button>
        </div>
    </div>
</template>

<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";
import { mapMutations, mapActions } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import VOtpInput from "vue3-otp-input";
import MemberService from "../services/member.service";
import StripeService from "../services/stripe.service";
import AirwallexService from "../services/airwallex.service";
import $ from "jquery";
import 'bootstrap/js/dist/modal'
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalCongratulation from "@/components/ModalCongratulation.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialTextarea from "@/components/MaterialTextarea.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import EventBus from "vue3-eventbus";
import Multiselect from "@vueform/multiselect";
import moment from "moment";
import { localStorageName, getMerchantCode, backToOnlineOrdering } from "@/config/utils";
import { dateLocale } from "@/i18n";
import { filterPhoneCodes } from "@/config/phoneCodes";
import TokenService from "../services/token.service";
import ModalConfirmDeactivateMember from "@/components/ModalConfirmDeactivateMember.vue";
import { errorMessage } from "@/utils/errorMessage";

export default {
    name: "Profile",
    components: {
        MaterialInput,
        MaterialButton,
        MaterialAlert,
        MaterialSnackbar,
        MaterialRadio,
        VOtpInput,
        ModalConfirm,
        ModalCongratulation,
        MaterialLoading,
        MaterialTextarea,
        Datepicker,
        MaterialCheckbox,
        Multiselect,
        ModalConfirmDeactivateMember
    },
    props: {
        propValue: String
    },
    data() {
        return {
            form: {
                id: '',
                name: '',
                last_name: '',
                nric: '',
                date_of_birth: '',
                gender: '',
                email: '',
                phone_number: '',
                address_1: '',
                address_2: '',
                postal_code: '',
                occupation: '',
                monthly_income_range: '1',
                marital_status: '',
                otp: '',
                discovery_channel: '',
                country_id: '',
                education: '',
                passcode: '',
                fields_another: [],
                isFinishedReward: 0, // 1 finished | 2 unfinished
                phone_code: '',
                receive_offers: 1
            },
            snackbar: null,
            error: '',
            yourValue: {},
            memberInfo: {},
            timerEnabled: true,
            countDown: 45,
            countDownText: 'Change',
            timeout: '',
            timer_on: 0,
            required: null,
            countries: [],
            phone_number_old: '',
            isShowOkOtpButton: true,
            isDisablePhoneInput: true,
            isShowShareData: true,
            merchantCode: "",
            voucherIconUrl: '',
            congratulationName: "",
            dateOfBirthBefore: null,
            isDisableGetOtpBtn: false,
            loaderActive: false,
            displayFields: null,
            reward: null,
            tier_have_membership_fee_min: null,
            check_birthday_reward: false,
            isWarningCannotUpdateBirthday: false,
            countryData: [],
            checkAllowForeignerPhoneNumber: null
        };
    },
    async created() {
        const code = getMerchantCode();
        var session_id = this.$route.query.session_id;
        var airwallex_intent_id = this.$route.query.airwallex_intent_id;

        if (session_id) {
            // call back after pay success - stripe
            this.loaderActive = true;
            await StripeService.checkCheckoutSessionStripe(
                { stripe_id: session_id },
                code,
            ).then(
                (response) => {
                    if (response.data.result.isSuccess) {
                        this.snackbar = 'success'
                        this.message = this.$t("profile.proceed_success")
                        this.setTimeOutNotification()
                        EventBus.emit("reloadSideNav");
                        this.$router.push(this.merchantCode + '/get-member-ship-success');
                    } else {
                        this.snackbar = 'danger'
                        this.message = errorMessage(response.data.result.message)
                        this.setTimeOutNotification()
                    }
                    this.loaderActive = false;
                },
                (error) => {
                    this.snackbar = 'danger'
                    this.message = errorMessage(error)
                    this.setTimeOutNotification()
                    this.loaderActive = false;
                }
            );
        } else if (airwallex_intent_id) {
            // call back after pay success - Airwallex HPP. Mirrors the Stripe
            // branch above; BE verifies the PI + dispatches ProcessWebhookJob
            // (handlePaidMembership) which upgrades the member's tier.
            this.loaderActive = true;
            await AirwallexService.checkHppAirwallex(
                { payment_intent_id: airwallex_intent_id },
                code,
            ).then(
                async (response) => {
                    // Checked once; drop the id before leaving, otherwise Back
                    // lands on it again, re-verifies and pushes forward again.
                    const query = { ...this.$route.query };
                    delete query.airwallex_intent_id;
                    await this.$router.replace({ query });

                    if (response.data.result.isSuccess) {
                        this.snackbar = 'success'
                        this.message = this.$t("profile.proceed_success")
                        this.setTimeOutNotification()
                        EventBus.emit("reloadSideNav");
                        this.$router.push(this.merchantCode + '/get-member-ship-success');
                    } else {
                        this.snackbar = 'danger'
                        this.message = errorMessage(response.data.result.message)
                        this.setTimeOutNotification()
                    }
                    this.loaderActive = false;
                },
                (error) => {
                    this.snackbar = 'danger'
                    this.message = error?.response?.data?.result?.message ?? this.$t('profile.airwallex_failed')
                    this.setTimeOutNotification()
                    this.loaderActive = false;
                }
            );
        }

        this.getCountriesForDropdown();
        this.getMemberInfo();
        this.getCountries();
    },
    mounted() {
        const code = getMerchantCode();
        this.merchantCode = code ? `/${code}` : '';

        const isAllowForeignerPhoneNumber = localStorage.getItem(localStorageName("ALLOW_FOREIGNER_PHONE_NUMBER"), 'false');
        this.checkAllowForeignerPhoneNumber = isAllowForeignerPhoneNumber;
        this.markPasscodeAsNewPassword();
    },
    updated() {
        // the passcode block renders later (v-if on displayFields), so re-apply after each render
        this.markPasscodeAsNewPassword();
    },
    computed: {
        styleObject() {
            return {
                '--label-color': this.$store.state.labelColor,
            };
        },
        phoneCodeOptions() {
            return filterPhoneCodes(this.countryData, this.form.phone_code);
        },
        initials() {
            return [this.form.name, this.form.last_name]
                .map((part) => String(part || '').trim().charAt(0))
                .join('')
                .toUpperCase();
        },
        // countDownText is 'Change' only outside the change-number flow (initial load, after save)
        isChangingPhone() {
            return this.countDownText !== 'Change';
        },
        // countDownText keeps its English sentinel values (isChangingPhone compares against 'Change'); translate for display only
        countDownLabel() {
            const text = this.countDownText;
            if (text === 'Change') return this.$t('profile.change');
            if (text === 'GET OTP') return this.$t('profile.get_otp_upper');
            if (text === 'Get OTP') return this.$t('profile.get_otp');
            const seconds = /^(\d+) s$/.exec(text);
            if (seconds) return this.$t('profile.n_seconds_short', { n: seconds[1] });
            return text;
        },
    },
    methods: {
        dateLocale,
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
        ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),

        sendOTP() {
            var _this = this;
            if(_this.isDisablePhoneInput) {
                _this.isDisablePhoneInput = !_this.isDisablePhoneInput;
                if(!this.timer_on) {
                    _this.countDownText = "GET OTP";
                    _this.isDisableGetOtpBtn = true
                } else {
                    $('.open-modal').click()
                }
                return;
            }
            let data = {
                'phone_code': _this.form.phone_code,
                'phone_number': _this.form.phone_number,
                'is_profile': 1
            }
            _this.closeSnackbar()
            if (this.timer_on && $("#exampleModal").is(":hidden")) {
                $('.open-modal').click()
            }
            if (!this.timer_on) {
                _this.$store.dispatch("auth/sendOtp", data).then(
                    (data) => {
                        if (data != undefined && !data.result.isSuccess) {
                            _this.message = errorMessage(data.result.message)
                            _this.snackbar = 'danger'
                        } else {
                            $('.open-modal').click()
                            _this.startCount()
                        }
                    },
                    (error) => {
                        console.log('ERROR' + error)
                    }
                );
            }
        },
        handleOnComplete: function (value) {
            this.form.otp = value
            this.isShowOkOtpButton = false;
        },
        handleOnChange: function (value) {
            if (value.length != 4) {
                this.form.otp = ''
                this.isShowOkOtpButton = true;
            }
        },
        handleOnCompletePasscode: function (value) {
            this.form.passcode = value
        },
        handleOnChangePasscode: function (value) {
            if (value.length != 4) {
                this.form.passcode = ''
            }
        },
        onChangePhoneNumber(event) {
            if (this.phone_number_old != event.target.value && event.target.value.length == 8) {
                this.isDisableGetOtpBtn = false
            } else {
                this.isDisableGetOtpBtn = true
            }
        },
        closeSnackbar() {
            this.snackbar = null;
        },
        // vue3-otp-input hard-codes autocomplete="off", which Chrome ignores for password fields: it then treats
        // the nearest text input above (Last Name) as the username and autofills the saved email into it.
        markPasscodeAsNewPassword() {
            if (!this.$el || !this.$el.querySelectorAll) return;
            this.$el.querySelectorAll('.mbr-pf__pin input[type="password"]').forEach((input) => {
                input.setAttribute('autocomplete', 'new-password');
            });
        },
        timedCount() {
            this.isDisablePhoneInput = true;
            if (this.countDown > 0) {
                this.countDown -= 1
                this.countDownText = `${this.countDown} s`
                this.timeout = setTimeout(this.timedCount, 1000);
            } else {
                this.countDownText = 'Get OTP'
            }

        },
        startCount() {
            if (!this.timer_on) {
                this.timer_on = 1
                this.isDisablePhoneInput = true
                this.timedCount()
            }
        },
        stopCount() {
            this.countDownText = 'Get OTP'
            this.isDisablePhoneInput = false
            clearTimeout(this.timeout);
            this.countDown = 45
            this.timer_on = 0
        },
        getMemberInfo() {
            this.showLoader();
            MemberService.getProfile().then(
                (response) => {
                    this.memberInfo = response.data.data
                    this.dateOfBirthBefore = this.memberInfo.date_of_birth ? this.memberInfo.date_of_birth : ''
                    this.form.email = this.memberInfo.email ? this.memberInfo.email : ''
                    this.form.phone_number = this.memberInfo.phone_number ? this.memberInfo.phone_number : ''
                    this.isShowShareData = this.memberInfo.is_populate_data;
                    this.required = this.memberInfo.fields.isRequired;
                    this.reward = this.memberInfo.fields.isReward;
                    this.displayFields = this.memberInfo.fields.isDisplay;
                    this.form.fields_another = this.memberInfo.fields_another;
                    this.tier_have_membership_fee_min = this.memberInfo.tier_have_membership_fee_min;
                    this.check_birthday_reward = this.memberInfo.check_birthday_reward
                    this.form.phone_code = this.memberInfo.phone_code ? this.memberInfo.phone_code : '';
                    if (this.isShowShareData) {
                       this.setDataprofile();
                    } else {
                        $(".btn-close").click()
                        $(".btn-share-profile-modal").click()
                    }
                    this.hideLoader();
                },
                (error) => {
                    this.hideLoader();
                    console.log(error);
                }
            );
        },
        setDataprofile() {
            this.form.id = this.memberInfo.id
            this.form.name = this.memberInfo.name ? this.memberInfo.name : ''
            this.form.last_name = this.memberInfo.last_name ? this.memberInfo.last_name : ''
            this.form.nric = this.memberInfo.nric ? this.memberInfo.nric : ''
            this.form.date_of_birth = this.memberInfo.date_of_birth ? this.memberInfo.date_of_birth : ''
            this.form.gender = this.memberInfo.gender ? String(this.memberInfo.gender) : ''
            this.form.address_1 = this.memberInfo.address_1 ? this.memberInfo.address_1 : ''
            this.form.address_2 = this.memberInfo.address_2 ? this.memberInfo.address_2 : ''
            this.form.postal_code = this.memberInfo.postal_code ? this.memberInfo.postal_code : ''
            this.form.occupation = this.memberInfo.occupation ? this.memberInfo.occupation : ''
            this.form.monthly_income_range = this.memberInfo.monthly_income_range ? this.memberInfo.monthly_income_range : '1'
            this.form.marital_status = this.memberInfo.marital_status ? this.memberInfo.marital_status : ''
            this.form.discovery_channel = this.memberInfo.discovery_channel ? this.memberInfo.discovery_channel : ''
            this.form.country_id = this.memberInfo.country_id ? this.memberInfo.country_id : ''
            this.form.education = this.memberInfo.education ? this.memberInfo.education : ''
            this.phone_number_old = this.memberInfo.phone_number ? this.memberInfo.phone_number : ''
            this.form.receive_offers = String(this.memberInfo.receive_offers);
            this.form.passcode = ''
        },
        getCountries() {
            MemberService.getCountries().then(
                (response) => {
                    if (response.data.result.isSuccess) {
                        this.countries = response.data.data
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        updateProfile() {
            this.closeSnackbar()
            if (this.processValidate(1)) {
                if(this.form.isFinishedReward == 2) {
                    $(".btn-finished-profile-reward-modal").click();
                } else {
                    this.handleUpdateProfile();
                }
            }
        },
        handleUpdateProfile() {
            this.form.isFinishedReward = 1;
            this.form.nric = this.form.nric.toString().toLocaleUpperCase();

            MemberService.updateProfile(this.form).then(
                (response) => {
                    var dataResponse = response.data;
                    if (dataResponse.result.isSuccess) {
                        this.snackbar = 'success'
                        this.message = this.$t("profile.update_success")
                        this.setTimeOutNotification()
                        this.getMemberInfo()
                        this.resetRequired();
                        this.stopCount()
                        this.countDownText = 'Change';
                        this.isDisablePhoneInput =  !this.isDisablePhoneInput;
                        this.isDisableGetOtpBtn = false
                        // console.log("dataResponse.data", dataResponse.data);
                        // if(dataResponse.data.is_get_reward && dataResponse.data.is_get_reward == true) {
                        //     // var name = dataResponse.data.name ?? "you"
                        //     // this.voucherIconUrl = dataResponse.data.voucher_icon_url
                        //     // this.congratulationName = "Congratulation,<br/> " + name + "!"
                        //     // $(".btn-show-modal-congratulation").click();
                        // } else {
                            // const isCheckMerchantConnectedStripe = localStorage.getItem("IS_CHECK_MERCHANT_CONNECTED_STRIPE", 'false');
                            // var count_paid_membership_reward_by_merchant = this.memberInfo.count_paid_membership_reward_by_merchant;
                            // if(!dataResponse.data.is_paid_member_ship && isCheckMerchantConnectedStripe === 'true' && count_paid_membership_reward_by_merchant > 0 && this.tier_have_membership_fee_min) {
                            // if(!dataResponse.data.is_paid_member_ship && isCheckMerchantConnectedStripe === 'true' && this.tier_have_membership_fee_min) {
                            //     this.$router.push(this.merchantCode + '/get-member-ship');
                            // }
                        // }
                        // $(".btn-show-modal-congratulation").click();
                        $(".btn-close-modal").click();

                        // Check if we need to redirect to online ordering after profile update
                        const branch_code = this.$route.query.branch_code ?? '';
                        const table_code = this.$route.query.table_code ?? '';
                        const from = this.$route.query.from ?? '';
                        const queue = this.$route.query.queue ?? false;
                        const token = TokenService.getLocalAccessToken();
                        var memberLogin = TokenService.getMember();

                        if(branch_code != "" && token && this.merchantCode) {
                            backToOnlineOrdering(this.merchantCode, branch_code, token, memberLogin?.data?.user?.id, table_code, from, queue);
                        } else {
                            setTimeout(() => { this.$router.push(this.merchantCode + '/home'); }, 1000);
                        }
                        EventBus.emit("reloadSideNav");
                        EventBus.emit("reloadMembershipCard");
                    } else {
                        this.snackbar = 'danger'
                        this.message = errorMessage(response.data.result.message)
                        this.setTimeOutNotification()
                    }
                },
                (error) => {
                    this.snackbar = 'danger'
                    this.message = errorMessage(error)
                    this.setTimeOutNotification()
                }
            );
        },
        setTimeOutNotification() {
            setTimeout(() => { this.snackbar = null; }, 3000);
        },
        resetRequired() {
            this.required.isNameRequire = false;
            this.required.isLastNameRequire = false;
            this.required.isNRICRequire = false;
            this.required.isDateRequire = false;
            this.required.isGenderRequire = false;
            this.required.isEmailRequire = false;
            this.required.isHouseAddressRequire = false;
            this.required.isPostCodeRequire = false;
            this.required.isOccupationRequire = false;
            this.required.isDiscoveryRequire = false;
            this.required.isMonthlyIncomeRangeRequire = false;
        },
        showMessage(message) {
            this.snackbar = 'danger'
            this.message = message
            this.setTimeOutNotification()
        },
        processValidate(isShowMessage) {
            // this.resetRequired();
            var isValid = true;
            if (this.displayFields.isNameDisplay && this.required.isNameRequire && this.form.name == '') {
                // this.required.isNameRequire = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.first_name') }));
                }
                isValid = false;
            }
            if (this.displayFields.isLastNameDisplay && this.required.isLastNameRequire && this.form.last_name == '') {
                // this.required.isLastNameDisplay = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.last_name') }));
                }
                isValid = false;
            }
            if (this.displayFields.isNRICDisplay && this.required.isNRICRequire && this.form.nric == '') {
                // this.required.isLastNameDisplay = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.nric_short') }));
                }
                isValid = false;
            }
            if (this.displayFields.isNameDisplay && this.reward.isNameReward && this.form.name == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isNameDisplay && this.reward.isLastNameReward && this.form.last_name == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isDateDisplay && this.required.isDateRequire && this.form.date_of_birth == '') {
                // this.required.isDateRequire = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.date_of_birth') }));
                }
                isValid = false;
            }
            if (this.displayFields.isDateDisplay && this.reward.isDateReward && this.form.date_of_birth == '') {
                this.form.isFinishedReward = 2;
            }  else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isGenderDisplay && this.required.isGenderRequire && this.form.gender == '') {
                // this.required.isGenderRequire = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.gender') }));
                }
                isValid = false;
            }
            if (this.displayFields.isGenderDisplay && this.reward.isGenderReward && this.form.gender == '') {
                this.form.isFinishedReward = 2;
            }  else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isEmailDisplay && this.required.isEmailRequire && this.form.email == '') {
                // this.required.isEmailRequire = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.email') }));
                }
                isValid = false;
            }

            if (this.displayFields.isEmailDisplay && this.form.email) {
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,64}$/i.test(this.form.email)) {
                    if(isShowMessage == 1) {
                        this.showMessage(this.$t("profile.invalid_email"));
                    }
                    isValid = false;
                }
            }

            if (this.displayFields.isEmailDisplay && this.reward.isEmailReward && this.form.email == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.form.phone_number == '') {
                // this.required.isPhoneRequire = true;
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.mobile_number') }));
                }
                isValid = false;
            }
            
            if (this.displayFields.isHouseAddressDisplay && this.required.isHouseAddressRequire &&  this.form.address_1 == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.address') }));
                }
                // this.required.isPostCodeRequire = true;
                isValid = false;
            }
            if (this.displayFields.isHouseAddressDisplay && this.reward.isHouseAddressReward &&  this.form.address_1 == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isPostCodeDisplay && this.required.isPostCodeRequire &&  this.form.postal_code == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.postal_code') }));
                }
                // this.required.isPostCodeRequire = true;
                isValid = false;
            }
            if (this.displayFields.isPostCodeDisplay && this.reward.isPostCodeReward &&  this.form.postal_code == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isDiscoveryDisplay && this.required.isDiscoveryRequire && this.form.discovery_channel == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.discovery_channel') }));
                }
                // this.required.isDiscoveryRequire = true;
                isValid = false;
            }
            if (this.displayFields.isDiscoveryDisplay && this.reward.isDiscoveryReward && this.form.discovery_channel == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isOccupationDisplay && this.required.isOccupationRequire && this.form.occupation == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.occupation') }));
                }
                // this.required.isDiscoveryRequire = true;
                isValid = false;
            }
            if (this.displayFields.isOccupationDisplay && this.reward.isOccupationReward && this.form.occupation == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isMonthlyIncomeRangeDisplay && this.required.isMonthlyIncomeRangeRequire && this.form.monthly_income_range == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.monthly_income_range') }));
                }
                // this.required.isDiscoveryRequire = true;
                isValid = false;
            }
            if (this.displayFields.isMonthlyIncomeRangeDisplay && this.reward.isMonthlyIncomeRangeReward && this.form.monthly_income_range == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isAddress2Display && this.required.isAddress2Require && this.form.address_2 == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.address_2') }));
                }
                isValid = false;
            }
            if (this.displayFields.isAddress2Display && this.reward.isAddress2Reward && this.form.address_2 == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isMaritalStatusDisplay && this.required.isMaritalStatusRequire && this.form.marital_status == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.marital_status') }));
                }
                isValid = false;
            }
            if (this.displayFields.isMaritalStatusDisplay && this.reward.isMaritalStatusReward && this.form.marital_status == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isCountryOfResidentDisplay && this.required.isCountryOfResidentRequire && this.form.country_id == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.country_of_resident') }));
                }
                isValid = false;
            }
            if (this.displayFields.isCountryOfResidentDisplay && this.reward.isCountryOfResidentReward && this.form.country_id == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isEducationDisplay && this.required.isEducationRequire && this.form.education == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.education') }));
                }
                isValid = false;
            }
            if (this.displayFields.isEducationDisplay && this.reward.isEducationReward && this.form.education == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            if (this.displayFields.isPasscodeDisplay && this.required.isPasscodeRequire && this.form.password == '') {
                if(isShowMessage == 1) {
                    this.showMessage(this.$t('profile.field_required', { field: this.$t('profile.passcode') }));
                }
                isValid = false;
            }
            if (this.displayFields.isPasscodeDisplay && this.reward.isPasscodeReward && this.form.password == '') {
                this.form.isFinishedReward = 2;
            } else {
                this.form.isFinishedReward = 1;
            }

            // check field another
            this.form.fields_another.map(element => {
                if (element.is_display === 1 && element.is_required === 1 && (element.field_value == null || element.field_value == false || element.field_value === "" || (element.field_value && element.field_value.length == 0))) {
                    if(isShowMessage == 1) {
                        this.showMessage(this.$t('profile.field_required', { field: element.field_name }));
                    }
                    isValid = false;
                }
                
                if (element.is_display === 1 && element.is_reward === 1 && (element.field_value == null || element.field_value == false || element.field_value === "" || (element.field_value && element.field_value.length == 0))) {
                    this.form.isFinishedReward = 2;
                }
            });

            return isValid;
        },
        processSycnProfile() {
            this.setDataprofile()
            $(".close-model").click()
        },
        goToMyReward() {
            $(".btn-show-modal-congratulation").click()
            this.$router.push(this.merchantCode + '/my-rewards');
        },
        showLoader() {
            this.loaderActive = true;
        },
  
        hideLoader() {
            this.loaderActive = false;
        },
        addMultipleChoice(itemRoot, itemChild) {
            const objectToUpdate = this.form.fields_another.find(obj => obj.id === itemRoot.id && obj.is_multiple_choice === 1);
            if (objectToUpdate) {
                if (!Array.isArray(objectToUpdate.field_value)) {
                    objectToUpdate.field_value = [];
                }
                const index = objectToUpdate.field_value.indexOf(itemChild.id);
                if (index !== -1) {
                    objectToUpdate.field_value.splice(index, 1);
                } else {
                    objectToUpdate.field_value.push(itemChild.id);
                }
            }
        },
        uploadFile(item) {
            $("#"+item.field_name_convert).click();
        },
        clearImage(item) {
            const objectToUpdate = this.form.fields_another.find(obj => obj.id === item.id && obj.is_file_upload === 1);
            objectToUpdate.field_value = "";
            if(objectToUpdate.field_value_preview) {
                objectToUpdate.field_value_preview = "";
            }
            objectToUpdate.isDelete = 2;
        },
        handleFileUpload(event, item) {
            let file = event.target.files[0];
            if (file != null || file != undefined) {
                if (
                    !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
                        file.type
                    )
                ) {
                    this.showMessage(this.$t("profile.file_must_be_image"));
                } else {
                    const objectToUpdate = this.form.fields_another.find(obj => obj.id === item.id && obj.is_file_upload === 1);
                    objectToUpdate.field_value = file;
                    objectToUpdate.field_value_preview = URL.createObjectURL(file);
                    objectToUpdate.isDelete = 1;
                }
            } else {
                this.showMessage(this.$t("profile.file_must_be_image"));
            }
        },
        warningCannotUpdateBirthday() {
            this.isWarningCannotUpdateBirthday = true;
            setTimeout(() => { this.isWarningCannotUpdateBirthday = false; }, 3000);
        },
        backToHome() {
            this.$router.push(this.merchantCode + '/home');
        },
        formatDate(date) {
            return moment(date).format("DD/MM/Y");
        },
        getCountriesForDropdown() {
            this.showLoader();
            MemberService.getCountriesForDropdown().then(
                (response) => {
                if (response.data.result.isSuccess) {
                    this.countryData = response.data.data;
                } else {
                    this.snackbar = "danger";
                    this.message = errorMessage(response.data.result.message);
                    this.setTimeOutNotification();
                }
                this.hideLoader();
                },
                (error) => {
                this.snackbar = "danger";
                this.message = errorMessage(error);
                this.hideLoader();
                this.setTimeOutNotification();
                }
            );
        },
        confirmDeactivateMember() {
            $('.btn-confirm-deactivate-member-modal').click();  
        },
        deactivateMember() {
            this.showLoader();
            MemberService.deactivate().then(
                (response) => {
                    if (response.data.result.isSuccess) {
                        this.message = this.$t("profile.deactivate_success");
                        this.snackbar = "success";
                        this.setTimeOutNotification();
                        setTimeout(() => {
                            this.$store.dispatch("auth/logout");
                            this.$router.push(this.merchantCode + '/sign-in');
                        }, 1000)
                    } else {
                        this.snackbar = "danger";
                        this.message = errorMessage(response.data.result.message);
                        this.setTimeOutNotification();
                    }
                    this.hideLoader();
                },
                (error) => {
                    this.snackbar = "danger";
                    this.message = errorMessage(error);
                    this.setTimeOutNotification();
                    this.hideLoader();
                }
            );
        }
    },
    watch: {
        countDown(newValue) {
            if (newValue == 0) {
                this.countDownText = 'Change';
                this.form.otp = ''
                this.stopCount()
                $('.btn-close').click()
            }
        },
        propValue: function(newVal) {
            if(newVal != "default_value") {
                if (this.processValidate(2)) {
                    this.form.nric = this.form.nric.toString().toLocaleUpperCase();

                    MemberService.updateProfile(this.form).then(
                        (response) => {
                            var dataResponse = response.data;
                            if (dataResponse.result.isSuccess) {
                                console.log("dataResponse", dataResponse);
                            } else {
                                console.log("dataResponse", dataResponse);
                                // this.snackbar = 'danger'
                                // this.message = errorMessage(response.data.result.message)
                                // this.setTimeOutNotification()
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
                }
            }
        }
    },
};
</script>
<style scoped>
.btn-share-profile {
    color: #007BFF !important;
    text-decoration: underline !important;
}

.title-share-profile {
    font-size: 13px;
    font-weight: 600;
}

.mbr-pf .mask {
    background: var(--mbr-color-canvas) !important;
    opacity: 1;
}

/* Landing/Store/RewardCatalogue leak `* { font-family: Poppins }`; icons keep their own font */
.mbr-pf :where(:not(.material-icons-round):not(.fa):not(.fas)) {
    font-family: var(--mbr-font-body);
}

.mbr-pf .card-body {
    padding: 8px 8px 0;
}

.mbr-pf__identity {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0 20px;
}

.mbr-pf__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background: var(--mbr-color-peach);
    border: 2px solid var(--mbr-color-surface);
    border-radius: var(--mbr-radius-full);
    box-shadow: var(--mbr-shadow-card);
    font-family: var(--mbr-font-headline) !important;
    font-size: 24px;
    font-weight: 800;
    color: var(--mbr-color-primary);
}

.mbr-pf__avatar .material-icons-round {
    font-size: 36px;
}

.mbr-pf__member-id {
    margin: 8px 0 0;
    font-size: var(--mbr-label-sm-size);
    font-weight: 600;
    line-height: var(--mbr-label-sm-line);
    color: var(--mbr-color-ink-secondary);
}

.mbr-pf__pair {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    gap: 12px;
}

.mbr-pf__field {
    margin-bottom: 20px;
}

.mbr-pf__label-row {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 16px;
    margin-bottom: 6px;
}

.mbr-pf__label {
    margin: 0;
    font-size: var(--mbr-label-caps-size);
    font-weight: var(--mbr-label-caps-weight);
    line-height: var(--mbr-label-caps-line);
    letter-spacing: var(--mbr-label-caps-tracking);
    text-transform: uppercase;
    color: var(--mbr-color-ink-muted);
}

.mbr-pf__req {
    color: var(--mbr-color-error);
}

.mbr-pf__gift {
    font-size: 13px;
    color: var(--mbr-color-gold);
}

.mbr-pf__link {
    margin-left: auto;
    padding: 0;
    background: none;
    border: 0;
    font-size: var(--mbr-label-sm-size);
    font-weight: 700;
    color: var(--mbr-color-primary);
}

.mbr-pf__link:hover {
    text-decoration: underline;
}

.mbr-pf__link:disabled {
    opacity: 0.5;
    text-decoration: none;
}

.mbr-pf__box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 56px;
    padding: 0 16px;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-lg);
    box-shadow: var(--mbr-shadow-card);
    text-align: left;
}

.mbr-pf__box--tint {
    background: var(--mbr-color-tint);
    box-shadow: none;
}

.mbr-pf__value {
    font-size: var(--mbr-body-md-size);
    font-weight: 600;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__value--placeholder {
    font-weight: 500;
    color: var(--mbr-color-ink-muted);
}

.mbr-pf__date {
    position: relative;
}

.mbr-pf__date-input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    opacity: 0;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
}

.mbr-pf__date-input::-webkit-calendar-picker-indicator {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.mbr-pf__date:focus-within {
    border-color: var(--mbr-color-primary);
}

.mbr-pf__box-icon {
    font-size: 20px;
    color: var(--mbr-color-primary);
}

.mbr-pf__error {
    display: block;
    margin-top: 6px;
    font-size: var(--mbr-label-sm-size);
    font-weight: 600;
    color: var(--mbr-color-error);
}

.mbr-pf__note {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 20px;
    padding: 14px;
    background: var(--mbr-color-tint);
    border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.6);
    border-radius: var(--mbr-radius-lg);
}

.mbr-pf__note-icon {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-top: 1px;
    background: var(--mbr-color-primary);
    border-radius: var(--mbr-radius-full);
    font-size: 11px;
    font-weight: 700;
    color: var(--mbr-color-on-primary);
}

.mbr-pf__note p {
    margin: 0;
    font-size: var(--mbr-label-sm-size);
    font-weight: 500;
    line-height: 1.6;
    color: var(--mbr-color-ink-secondary);
}

.mbr-pf__segment {
    display: flex;
    padding: 6px;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    box-shadow: var(--mbr-shadow-card);
}

.mbr-pf__segment-btn {
    flex: 1;
    padding: 10px 0;
    background: transparent;
    border: 0;
    border-radius: var(--mbr-radius-full);
    font-size: var(--mbr-label-sm-size);
    font-weight: 600;
    color: var(--mbr-color-ink-secondary);
    transition: background-color 0.15s ease, color 0.15s ease;
}

.mbr-pf__segment-btn.is-active {
    background: var(--mbr-color-primary);
    box-shadow: var(--mbr-shadow-card);
    font-weight: 700;
    color: var(--mbr-color-on-primary);
}

.mbr-pf__segment-btn:focus-visible {
    outline: 2px solid var(--mbr-color-primary);
    outline-offset: 2px;
}

.mbr-pf__phone {
    display: flex;
    align-items: center;
    gap: 12px;
}

.mbr-pf__phone strong {
    font-size: var(--mbr-body-md-size);
    font-weight: 700;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__divider {
    width: 1px;
    height: 20px;
    background: var(--mbr-color-outline);
}

.mbr-pf__verified {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: var(--mbr-label-caps-size);
    font-weight: 600;
    color: var(--mbr-color-positive);
}

.mbr-pf__verified .material-icons-round {
    font-size: 14px;
}

.mbr-pf__phone-edit {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* !important outranks Material Dashboard's underline .form-select */
.mbr-pf__select {
    width: 100%;
    height: 56px;
    padding: 0 32px 0 16px !important;
    background-color: var(--mbr-color-surface) !important;
    background-position: right 10px center;
    border: 1px solid var(--mbr-color-outline) !important;
    border-radius: var(--mbr-radius-lg) !important;
    font-size: var(--mbr-body-md-size);
    font-weight: 600;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__select:disabled {
    background-color: var(--mbr-color-tint) !important;
}

.mbr-pf__select--code {
    flex: 0 0 auto;
    width: auto;
}

.mbr-pf__phone-input {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
}

.mbr-pf__otp-btn {
    flex: 0 0 auto;
    height: 56px;
    padding: 0 16px;
}

.mbr-pf__choices {
    display: flex;
    flex-direction: column;
    padding: 6px 16px;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-lg);
    box-shadow: var(--mbr-shadow-card);
}

/* !important outranks Material Dashboard's .form-check padding */
.mbr-pf__choices .mbr-radio,
.mbr-pf__inline-choices .mbr-radio {
    display: flex;
    align-items: center;
    min-height: 44px;
    margin: 0;
    padding-left: 0 !important;
}

/* Outranks the global `.form-check:not(.form-switch) .form-check-input { margin-left: auto !important }`,
   which pushes the dot to the far right of a full-width row */
.mbr-pf__choices .form-check.mbr-radio :deep(.form-check-input.mbr-radio__input),
.mbr-pf__inline-choices .form-check.mbr-radio :deep(.form-check-input.mbr-radio__input) {
    margin-left: 0 !important;
}

.mbr-pf__check {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 44px;
}

.mbr-pf__check .mbr-checkbox {
    margin: 0;
}

.mbr-pf__check-label {
    font-size: var(--mbr-body-md-size);
    font-weight: 500;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__question {
    margin: 0 0 4px;
    font-size: var(--mbr-label-md-size);
    font-weight: 600;
    line-height: var(--mbr-label-md-line);
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__inline-choices {
    display: flex;
    gap: 24px;
}

.mbr-pf__picker :deep(.dp__input) {
    height: 56px;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-lg);
    box-shadow: var(--mbr-shadow-card);
    font-family: var(--mbr-font-body);
    font-size: var(--mbr-body-md-size);
    font-weight: 600;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__picker :deep(.dp__input_focus),
.mbr-pf__picker :deep(.dp__input:hover) {
    border-color: var(--mbr-color-primary);
}

.mbr-pf__picker :deep(.dp__input_icon) {
    color: var(--mbr-color-primary);
}

.mbr-pf__multiselect {
    --ms-font-size: 15px;
    --ms-line-height: 1.5;
    --ms-py: 15px;
    --ms-radius: 16px;
    --ms-border-color: var(--mbr-color-outline);
    --ms-border-color-active: var(--mbr-color-primary);
    --ms-ring-color: rgba(var(--mbr-color-primary-rgb), 0.12);
    --ms-caret-color: var(--mbr-color-primary);
    --ms-dropdown-radius: 16px;
    --ms-dropdown-border-color: var(--mbr-color-outline);
    --ms-option-bg-pointed: var(--mbr-color-tint);
    --ms-option-color-pointed: var(--mbr-color-ink-headline);
    --ms-option-bg-selected: var(--mbr-color-primary);
    --ms-option-bg-selected-pointed: var(--mbr-color-primary-light);
    --ms-option-color-selected: var(--mbr-color-on-primary);
    --ms-option-color-selected-pointed: var(--mbr-color-on-primary);
    width: 100%;
    margin: 0;
    font-weight: 600;
    color: var(--mbr-color-ink-headline);
    box-shadow: var(--mbr-shadow-card);
}

.mbr-pf__upload {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
}

.mbr-pf__hint {
    font-size: var(--mbr-label-sm-size);
    font-weight: 500;
    color: var(--mbr-color-ink-muted);
}

.mbr-pf__thumb {
    position: relative;
    width: 88px;
    height: 88px;
    margin-top: 12px;
}

.mbr-pf__thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-md);
}

.mbr-pf__thumb-remove {
    position: absolute;
    top: -8px;
    right: -8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    color: var(--mbr-color-error);
}

.mbr-pf__thumb-remove .material-icons-round {
    font-size: 16px;
}

.mbr-pf__pin {
    display: flex;
}

/* !important outranks the global underline .otp-input in custom.css */
.mbr-pf__pin :deep(.otp-input) {
    width: 56px;
    height: 56px;
    margin: 0 12px 0 0;
    padding: 0;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline) !important;
    border-radius: var(--mbr-radius-lg);
    box-shadow: var(--mbr-shadow-card);
    font-size: 20px;
    font-weight: 700;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf__pin :deep(.otp-input:focus) {
    border-color: var(--mbr-color-primary) !important;
}

.mbr-pf__deactivate-row {
    margin: 8px 0 24px;
    text-align: center;
}

/* Material Dashboard's .page-header clips overflow, which would stop the Save bar sticking */
.mbr-pf.page-header {
    overflow: visible;
}

.mbr-pf__savebar {
    position: sticky;
    bottom: 0;
    z-index: 3;
    margin: 4px -24px 0;
    padding: 20px 24px;
    background: rgba(var(--mbr-color-canvas-rgb), 0.95);
    border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
}

.mbr-pf__save {
    font-weight: 800;
    box-shadow: 0 8px 20px rgba(var(--mbr-color-primary-rgb), 0.25);
}

.mbr-pf__pin-hint {
    margin: 0 0 8px;
    font-size: var(--mbr-label-sm-size);
    font-weight: 500;
    text-align: center;
    color: var(--mbr-color-ink-muted);
}

.mbr-pf__pin--center {
    justify-content: center;
    margin-top: 12px;
}

.mbr-pf__pin--center :deep(.otp-input) {
    margin: 0 6px;
}

.mbr-pf-modal {
    padding: 24px;
    background: var(--mbr-color-canvas);
    border: 0;
    border-radius: var(--mbr-radius-xl);
    box-shadow: var(--mbr-shadow-modal);
}

.mbr-pf-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on headings */
.mbr-pf-modal__title {
    margin: 0;
    font-family: var(--mbr-font-headline) !important;
    font-size: var(--mbr-headline-sm-size);
    font-weight: 800;
    line-height: var(--mbr-headline-sm-line);
    color: var(--mbr-color-ink-headline);
}

/* Reset Bootstrap's .btn-close background icon and opacity */
.mbr-pf-modal__close {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    padding: 0;
    background: var(--mbr-color-surface) none;
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    opacity: 1;
    color: var(--mbr-color-ink-headline);
}

.mbr-pf-modal__close .material-icons-round {
    font-size: 20px;
}

.mbr-pf-modal__body {
    text-align: center;
}

.mbr-pf-modal__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
}

.mbr-pf-modal__countdown {
    font-size: var(--mbr-label-md-size);
    font-weight: 600;
    color: var(--mbr-color-ink-secondary);
}

.mbr-pf-sheet .modal-dialog {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
}

.mbr-pf-sheet__content {
    padding: 12px 24px 28px;
    background: var(--mbr-color-canvas);
    border: 0;
    border-radius: 28px 28px 0 0;
    box-shadow: var(--mbr-shadow-modal);
}

.mbr-pf-sheet__top {
    position: relative;
    display: flex;
    justify-content: flex-end;
    min-height: 36px;
}

.mbr-pf-sheet__handle {
    position: absolute;
    top: 0;
    left: 50%;
    width: 40px;
    height: 4px;
    background: var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    transform: translateX(-50%);
}

.mbr-pf-sheet__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 8px 0 24px;
    text-align: center;
}

.mbr-pf-sheet__title {
    margin: 0;
    font-family: var(--mbr-font-headline) !important;
    font-size: var(--mbr-headline-sm-size);
    font-weight: 800;
    line-height: var(--mbr-headline-sm-line);
    color: var(--mbr-color-ink-headline);
}

.mbr-pf-sheet__emblem {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    height: 88px;
    background: var(--mbr-color-peach);
    border-radius: var(--mbr-radius-full);
    font-size: 40px;
    color: var(--mbr-color-gold);
}

.mbr-pf-sheet__sub {
    margin: 0;
    font-size: var(--mbr-body-md-size);
    font-weight: 500;
    color: var(--mbr-color-ink-secondary);
}

.mbr-pf-sheet__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.mbr-pf__deactivate {
    padding: 8px;
    background: none;
    border: 0;
    font-size: var(--mbr-label-md-size);
    font-weight: 600;
    color: var(--mbr-color-ink-secondary);
    text-decoration: underline;
}
</style>